//Create gel box instance
export const createGelBox = data => {
  //data = {id, type}
  return { type: "CREATE_GEL_BOX", payload: data };
};

export const setGelBox = data => {
  //data = {...}
  return { type: "SET_GEL_BOX", payload: data };
};

export const setGelInBox = data => {
  //data = {id, containsGel}
  return { type: "SET_GEL_IN_BOX", payload: data };
};

export const setSolutionInGelBox = data => {
  //data = {id, containsGel}
  return { type: "SET_SOLUTION_IN_GEL_BOX", payload: data };
};

export const setGelOrientation = data => {
  //data =  {id, gelOrientation}
  return { type: "SET_GEL_ORIENTATION", payload: data };
};

export const incGelOrientation = data => {
  //data =  {id, gelOrientation}
  return { type: "INC_GEL_ORIENTATION", payload: data };
};

export const decGelOrientation = data => {
  //data =  {id, gelOrientation}
  return { type: "DEC_GEL_ORIENTATION", payload: data };
};

export const setGelBoxTimer = data => {
  //data = {id, timer}
  return { type: "SET_GEL_BOX_TIMER", payload: data };
};

export const setGelBoxActive = data => {
  //data = {id, active}
  return { type: "SET_GEL_BOX_ACTIVE", payload: data };
};

export const gelBoxOpen = data => {
  //data = {id, cover}
  console.log('opening gel box: payload is: ', data);
  return { type: "SET_GEL_BOX_OPEN", payload: data };
};

export const setGelBoxAnodeConnected = data => {
  //data = {id, anodeConnected}
  return { type: "SET_GEL_BOX_ANODE_CONNECTED", payload: data };
};

export const setGelBoxCathodeConnected = data => {
  //data = {id, cathodeConnected}
  return { type: "SET_GEL_BOX_CATHODE_CONNECTED", payload: data };
};

export const ejectGelFromGelBox = data => {
  return { type: "EJECT_GEL_FROM_GEL_BOX", payload: data };
};

export const toggleToolTipControls = data => {
  return { type: "SHOW_TOOL_TIP_CONTROLS", payload: data };
};

export const toggleGelboxTooltipsControls = (data) => {
  return { type: "GELBOX_TOGGLE_TOOLTIP_CONTROLS", payload: data}
}

export const toggleGelboxOrientationModal= (data) => {
  return { type: "GELBOX_TOGGLE_ORIENTATION_MODAL", payload: data}
}

export const toggleGelboxPipetteModal= (data) => {
  return { type: "GELBOX_TOGGLE_GELPIPETTE_MODAL", payload: data}
}
